export default __webpack_public_path__ + "static/media/trending.e7d3f9d2.svg";